import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';
import { cn } from '#cn';
type SwitchProps = {
  checked: boolean;
  onChange: () => void;
  label?: string;
  className?: string;
};

/** A toggle switch (`role="switch"`) — fully controlled via `checked`/`onChange`. */
export const Switch = t0 => {
  const $ = _c(13);
  const {
    checked,
    onChange,
    label,
    className
  } = t0;
  const t1 = checked ? "bg-[#45eba3]" : "bg-border-strong";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("inline-flex h-[18px] w-[33px] shrink-0 rounded-full transition-colors duration-200 focus:outline-none", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = checked ? "translate-x-[17px]" : "translate-x-0.5";
  let t4;
  if ($[3] !== t3) {
    t4 = cn("inline-block h-3.5 w-3.5 rounded-full bg-surface shadow-sm transition-transform duration-200 translate-y-0.5", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <span className={t4} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== checked || $[8] !== label || $[9] !== onChange || $[10] !== t2 || $[11] !== t5) {
    t6 = <button type="button" role="switch" aria-checked={checked} aria-label={label} onClick={onChange} className={t2}>{t5}</button>;
    $[7] = checked;
    $[8] = label;
    $[9] = onChange;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};